class @SchedulableForm

  @setup: (idPrefix) ->
    # Get references to the various fields on the page that have to do with the
    # scheduling options.

    $beginsAt               = $("##{idPrefix}_begins_at")
    $beginsAtContainer      = $beginsAt.closest(".form-field")
    $beginsAtValue          = $("##{idPrefix}_begins_at_value")
    $beginsAtValueContainer = $beginsAtValue.closest(".form-field")
    $form                   = $beginsAt.closest("form")

    # Don't continue if the fields we're looking for aren't on this page.
    return if $beginsAt.length == 0 || $beginsAtContainer.length == 0
    return if $beginsAtValue.length == 0 || $beginsAtValueContainer.length == 0
    return if $form.length == 0

    # The begins_at_value field is automatically parsed as a time.

    $beginsAtValue.timeParsedInput()

    # Define how we adjust the display.

    adjustForScheduleSelection = ->
      if $beginsAt.val() == ""
        $beginsAtValueContainer.slideDown 250, ->
          $beginsAtValue.focus()
      else
        $beginsAtValueContainer.slideUp 250

    $beginsAt.change adjustForScheduleSelection

    # Set up the initial input display.

    adjustForScheduleSelection()

    if $beginsAtValue.val() != "" || $beginsAtValueContainer.hasClass("field_with_errors")
      $beginsAt.val("")
      $beginsAtValueContainer.show()

    # Push the begins_at field into the begins_at_value field if it's been
    # selected.

    $form.submit ->
      beginsAt = $beginsAt.val()
      $beginsAtValue.val(beginsAt) if beginsAt != ""
      return true
